import { ActionContext, ActionTree } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { AuctionState } from './AuctionState'
import { Offer } from './Offer'
import { SendEncryptedOfferResponseDto } from '@/Application/XmlOffer/SendEncryptedOfferResponseDto'

export const actions: ActionTree<AuctionState, RootState> = {
  clearAuctionAll: (context: ActionContext<AuctionState, RootState>) => {
    context.commit('clearAuctionAll')
  },
  clearAuctionB: (context: ActionContext<AuctionState, RootState>) => {
    context.commit('clearAuctionB')
  },
  setLastWizardStep: (context: ActionContext<AuctionState, RootState>, payload: number) => {
    context.commit('setLastWizardStep', payload)
  },
  upsertOffer: (context: ActionContext<AuctionState, RootState>, payload: Offer) => {
    context.commit('upsertOffer', payload)
  },
  clearOffers: (context: ActionContext<AuctionState, RootState>) => {
    context.commit('clearOffers')
  },
  setResultPost: (context: ActionContext<AuctionState, RootState>, payload: SendEncryptedOfferResponseDto) => {
    context.commit('setResultPost', payload)
  }
}
